import {combineReducers} from 'redux';
import TextColumnsMultipleMediaReducer from './text_columns_multiple_media.js';

const sectionReducer = combineReducers({
    textColumnsMultipleMedia: TextColumnsMultipleMediaReducer,
});

export default sectionReducer;



// WEBPACK FOOTER //
// ./src/containers/builder/sections/reducers/index.js